window.confirmSize = (event) => {
  const variant = product.variants.find((v) => v.id == event.detail.code);
  if (!variant) return;
  variant.options.forEach((optionValue, index) => {
    const optionName = product.options[index];
    const escapedOptionValue = optionValue.replace(/"/g, '\\"');
    const selector = `input[name^="${optionName}"][title="${escapedOptionValue}"]`;
    const element = document.querySelector(selector);
    element?.click();
  });
};

(function(){
  function handleVariantChange(evt){
    try {
      var data = evt && (evt.data || evt.detail) || {};
      var variant = data.variant || data.selectedVariant || {};
      var vid = variant.id || data.variantId || data.id;
      if(!vid) return;
      var widget = document.querySelector('#onlinesizing-widget');
      if(widget){ widget.setAttribute('variant-id', vid); }
    } catch(e) { /* no-op */ }
  }

  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS && PUB_SUB_EVENTS.variantChange) {
    subscribe(PUB_SUB_EVENTS.variantChange, handleVariantChange);
  } else {
    document.addEventListener('variant:change', handleVariantChange);
    document.addEventListener('variantChange', handleVariantChange);
    document.addEventListener('product:variant-change', handleVariantChange);
  }
})();

(function () {
  var loadingSelector = '.oz-widget-container-pdp--loading';
  var pollTimer;
  var fallbackTimer;

  function widgetIsReady(widget) {
    return widget && widget.status && widget.status.status === 0;
  }

  function revealReadyWidgets() {
    var loadingContainers = Array.from(document.querySelectorAll(loadingSelector));

    loadingContainers.forEach(function (container) {
      var sizingWidget = container.querySelector('oz-widget');
      var geometryWidget = container.querySelector('oz-geometry');

      if (widgetIsReady(sizingWidget) && widgetIsReady(geometryWidget)) {
        container.classList.remove('oz-widget-container-pdp--loading');
      }
    });

    if (!document.querySelector(loadingSelector)) {
      window.clearInterval(pollTimer);
      window.clearTimeout(fallbackTimer);
    }
  }

  function initializeWidgetLoadingState() {
    revealReadyWidgets();
    pollTimer = window.setInterval(revealReadyWidgets, 100);
    fallbackTimer = window.setTimeout(function () {
      document.querySelectorAll(loadingSelector).forEach(function (container) {
        container.classList.remove('oz-widget-container-pdp--loading');
      });
      window.clearInterval(pollTimer);
    }, 8000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializeWidgetLoadingState, { once: true });
  } else {
    initializeWidgetLoadingState();
  }
})();
